import Head from "next/head"
import { t } from "translations"

import { IMegamenuCategory } from "data/contentData/interfaces/IMegamenuCategory"
import { IContainerCard } from "data/contentData/interfaces/mongodb/IContainerCard"
import { getStaticLayoutProps } from "lib/getStaticLayoutProps"

import Layout from "Components/Layout/Layout"
import ContractionCounter from "Components/PregnancyOracle/ContractionCounter/ContractionCounter"
import ToolTemplatePage from "Components/PregnancyOracle/ToolTemplatePage"

export default function ContractionCounterPage({
    footer,
    megamenu
}: {
    footer: IContainerCard[]
    megamenu: IMegamenuCategory[]
}) {
    return (
        <Layout
            footer={footer}
            megamenu={megamenu}>
            <Head>
                <title>
                    {t.contractionCounter.title} | {t.siteTitle}
                </title>
                <meta
                    name="description"
                    content={`${t.contractionCounter.title}  | ${t.siteTitle}`}
                    key="desc"
                />
            </Head>
            <ToolTemplatePage
                toolItem={<ContractionCounter />}
                instructionTitle={t.contractionCounter.instruction}
                instructions={[
                    {
                        icon: "start",
                        instructionText: t.contractionCounter.instructionStart
                    },
                    {
                        icon: "stop",
                        instructionText: t.contractionCounter.instructionStop
                    },
                    {
                        icon: "pregnancyOracleClock",
                        instructionText:
                            t.contractionCounter.instructionDescription
                    },
                    {
                        icon: "print",
                        instructionText: t.contractionCounter.instructionPrint
                    }
                ]}
                accordions={[
                    {
                        title: t.contractionCounter.signsOfBirthTitle,
                        text: t.contractionCounter.signOfBirthDescription
                    },
                    {
                        title: t.contractionCounter.signsOfContractionsTitle,
                        text: t.contractionCounter
                            .signsOfContractionsDescription
                    }
                ]}
                cloudText={t.contractionCounter.contactHospital}
            />
        </Layout>
    )
}

export const getStaticProps = getStaticLayoutProps
